"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyCdNumberMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const policy_entity_1 = require("./policy.entity");
const opportunity_placement_slip_cd_detail_entity_1 = require("./opportunity-placement-slip-cd-detail.entity");
let PolicyCdNumberMap = class PolicyCdNumberMap {
};
exports.PolicyCdNumberMap = PolicyCdNumberMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], PolicyCdNumberMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyCdNumberMap.prototype, "policyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cd_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], PolicyCdNumberMap.prototype, "cdId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], PolicyCdNumberMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], PolicyCdNumberMap.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => policy_entity_1.Policy, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "policy_id" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _c : Object)
], PolicyCdNumberMap.prototype, "policy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_placement_slip_cd_detail_entity_1.OpportunityPlacementSlipCDDetail, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "cd_id" }),
    tslib_1.__metadata("design:type", typeof (_d = typeof typeorm_1.Relation !== "undefined" && typeorm_1.Relation) === "function" ? _d : Object)
], PolicyCdNumberMap.prototype, "cdDetail", void 0);
exports.PolicyCdNumberMap = PolicyCdNumberMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("policy_cd_number_map")
], PolicyCdNumberMap);
